import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  credentialId: '',
  resource: 'employee',
  action: 'getAllEmployees',
  employeeId: '',
  firstName: '',
  lastName: '',
  email: '',
  startDate: '',
  endDate: '',
  department: '',
  jobRole: '',
  reportsTo: '',
  leaverDate: '',
  reasonForLeaving: '',
  oldEmployeeId: '',
  newEmployeeId: '',
  reasonForChange: '',
  absenceId: '',
  reason: '',
  absenceType: '',
  holidayId: '',
  holidayType: '',
  comments: '',
  salaryId: '',
  effectiveDate: '',
  amount: 0,
  currency: 'GBP',
  payFrequency: '',
};

export default defaults;
